/**
 * REMOAT's "Sign in with MedicAI" opens `/remoat/sign-in`. When the person has to log in first, that page leaves this
 * marker in the tab's sessionStorage so the login goes back to it instead of the schedule. Only this fixed path is
 * ever returned, and only within 15 minutes, so a normal login is never redirected.
 */
const KEY = 'remoatSignIn';
const TTL_MS = 15 * 60 * 1000;
export const REMOAT_SIGN_IN_PATH = '/remoat/sign-in';

export function markRemoatSignIn(storage: Storage = sessionStorage, now = Date.now()): void {
  storage.setItem(KEY, String(now));
}

/** The REMOAT sign-in path when this login started there; the marker is spent either way. */
export function takeRemoatReturn(storage: Storage = sessionStorage, now = Date.now()): string | null {
  const marked = Number(storage.getItem(KEY));
  storage.removeItem(KEY);
  return Number.isFinite(marked) && marked > 0 && now - marked <= TTL_MS ? REMOAT_SIGN_IN_PATH : null;
}
